// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/body/assetstores.styl
// module id = 377
// module chunks = 0